var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompareIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H25C26.933 0.5 28.5 2.067 28.5 4V24C28.5 25.933 26.933 27.5 25 27.5H4C2.067 27.5 0.5 25.933 0.5 24V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "white",
    stroke: "#CD2A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2092 20.0118L20.2704 23.6603L12.3171 17.1976L20.2704 11.0352L20.237 14.3889H27.0001V20.0118H20.2092Z",
    stroke: "#CD2A3F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.9766V8.34817H8.76307L8.7297 5L16.683 11.1624L8.7297 17.6251L8.79644 13.9766H2Z",
    stroke: "#CD2A3F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareIconNew);
export default __webpack_public_path__ + "static/media/compare_icon_new.7f366dccac656404de68005b184d6c4b.svg";
export { ForwardRef as ReactComponent };